import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<path d="M23.38,15.43c-0.71-1.19-1.42-2.37-2.13-3.56c-0.07-0.12-0.07-0.21,0.01-0.33c0.65-0.96,1.29-1.93,1.93-2.9
	c0.02-0.04,0.04-0.08,0.06-0.13c-0.04-0.01-0.06-0.01-0.08-0.01c-1.09,0-2.19,0-3.28,0c-0.05,0-0.11,0.05-0.14,0.09
	c-0.39,0.65-0.78,1.29-1.16,1.94c-0.12,0.2-0.24,0.39-0.36,0.59c-0.01,0-0.03,0-0.04-0.01c-0.01-0.05-0.02-0.11-0.02-0.16
	c0-0.76,0-1.51,0-2.27c0-0.2,0-0.2-0.2-0.2c-1.63,0-3.26,0.01-4.88,0c-0.15,0-0.21,0.06-0.24,0.19c-0.05,0.22-0.11,0.44-0.16,0.66
	c-0.17,0.67-0.34,1.33-0.52,1.99c-0.03,0.11-0.07,0.22-0.11,0.37c-0.04-0.07-0.06-0.1-0.07-0.13c-0.04-0.14-0.09-0.29-0.13-0.43
	c-0.24-0.83-0.48-1.65-0.71-2.48c-0.04-0.14-0.11-0.18-0.24-0.18C9.3,8.52,7.7,8.52,6.11,8.52c-0.2,0-0.2,0-0.2,0.2
	c0,0.92,0,1.84,0,2.76c0,0.05,0,0.1-0.01,0.15c-0.07-0.04-0.11-0.09-0.14-0.15c-0.63-0.95-1.25-1.9-1.88-2.85
	C3.83,8.56,3.77,8.52,3.67,8.52c-0.96,0-1.92,0-2.88,0c-0.13,0-0.17,0.04-0.16,0.17c0,2.26,0,4.52,0,6.79
	c0,0.13,0.04,0.15,0.16,0.15c0.95,0,1.9,0,2.85,0c0.13,0,0.16-0.04,0.16-0.17c0-0.94,0-1.89,0-2.83c0-0.05,0-0.1,0.01-0.14
	c0.06,0.04,0.09,0.08,0.12,0.13c0.57,0.94,1.15,1.89,1.72,2.83c0.07,0.11,0.14,0.15,0.28,0.15c1.14-0.01,2.29,0,3.43,0
	c0.2,0,0.2,0,0.2-0.2c0-1.33,0-2.66,0-4c0-0.07,0.01-0.13,0.02-0.2c0.01,0,0.02,0,0.04,0c0.01,0.03,0.03,0.07,0.04,0.1
	c0.09,0.32,0.18,0.64,0.28,0.96c0.17,0.58,0.34,1.15,0.5,1.73c0.14,0.49,0.29,0.98,0.43,1.48c0.02,0.09,0.06,0.13,0.16,0.13
	c0.68,0,1.37,0,2.05,0c0.1,0,0.14-0.03,0.17-0.13c0.17-0.67,0.36-1.35,0.54-2.02c0.17-0.62,0.33-1.23,0.5-1.85
	c0.04-0.16,0.09-0.31,0.14-0.47c0.01,0,0.03,0.01,0.04,0.01c0,0.04,0.01,0.07,0.01,0.11c0,1.39,0,2.77-0.01,4.16
	c0,0.15,0.04,0.19,0.19,0.19c1.11-0.01,2.22-0.01,3.33-0.01c0.2,0,0.2,0,0.2-0.2c0-0.83,0-1.66,0-2.49c0-0.06,0.01-0.11,0.02-0.17
	c0.01,0,0.02,0,0.04,0c0.02,0.04,0.05,0.08,0.07,0.12c0.43,0.86,0.85,1.72,1.27,2.59c0.06,0.11,0.12,0.16,0.25,0.16
	c1.15-0.01,2.31,0,3.46,0c0.05,0,0.1,0,0.18-0.01C23.42,15.52,23.4,15.47,23.38,15.43z"/>      </svg>
    </SvgIcon>
  )
}
